import React from 'react';
import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined } from '@ant-design/icons';
import axios from 'axios';
import Tab1 from './Tab1';
import Utilisateur from '../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import Data from '../../../Data/Data.json';
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../Functions/Security/Crypter';
import { Box, Typography } from '@mui/material';
import Tab2 from './Tab2';
import ReformatDate from '../../../Functions/Traitement/ReformatDate';
import CLIENT from '../../../Models/Client';
import Tab3 from './Tab3';
import { emphasize, styled } from '@mui/material/styles';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Chip from '@mui/material/Chip';
import HomeIcon from '@mui/icons-material/Home';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InputForm from '../../InputT';
import COMPTES from '../../../Models/Comptes';

//import "../../Assets/Styles/StyleForm.css";


const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === 'light'
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
}) as typeof Chip;

//client Physique
const ControlCpt = () => {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [sbmit, setSbmit] = useState("")
  const [Activetabs, SetActivetabs] = useState(false);

  useEffect(() => {
    forceUpdate({});
  }, []);

  function initialiazeButton() {
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
  }

  const SetStart = () => {
    setSbmit("add")
    setAjoutActif(true)
    setEnregActve(false)
    setAnnulActive(false)
    setConsulActive(true)
    form.resetFields()
    form.setFieldValue("niveau", 900)
  }

  const SetEndStart = () => {
    SetStartForm(true);
    SeStartSearchG(false)
  }
  function handleAnulle() {
    SetActivetabs(false)
    let coduti = form.getFieldValue("CODUTI")
    form.resetFields()
    localStorage.clear()
    form.setFieldValue("CODUTI", coduti)
    initialiazeButton()
    localStorage.setItem(Data.LocalVariable.reset, "1")
    //localStorage.setItem(Data.LocalVariable.resetTable, "1")
  }
  function cunsultButton() {
    SetActivetabs(true);
    setAnnulActive(false)
    setModifActve(false)

  }

  function modifButton() {
    setSbmit("update")
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
    SetActivetabs(false)
  }


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span>
          <UserOutlined />
          Information comptes
        </span>
      ),
      children: <Tab1 etatG={StartSearchG} form={form} />,
    },
    {
      key: '2',
      label: (
        <span>
          <ContactsOutlined />
          Interets et commissions
        </span>
      ),
      children: <Tab2 form={form} />,
    }
    ,
    {
      key: '3',
      label: (
        <span>
          <ContactsOutlined />
          Conditions spéciales
        </span>
      ),
      children: <Tab3 form={form} />,
    }
  ];

  const onFinish = (values: any) => {
    var Compte = values
    Compte.UTILIS = user.coduti;

    console.log(Compte)


    if (sbmit == "update") {

      switch (Compte.CALINT) {
        case true:
          Compte.CALINT = 'O';
          break
        case false:
          Compte.CALINT = 'N';
          break
        default:
          Compte.CALINT = '';
      }

      switch (Compte.CALCOM) {
        case true:
          Compte.CALCOM = 'O';
          break
        case false:
          Compte.CALCOM = 'N';
          break
        default:
          Compte.CALCOM = '';
      }


      //console.log(values)
      SweetAlert.fire({
        title: "Condition Spéciale",
        text: "Voulez-vous appliqué les conditions au compte " + Compte.NUMCPT + " ?",
        showCancelButton: true,
        color: "#116599",
        confirmButtonText: "Yes",
        confirmButtonColor: "#116599",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {
          setLoading(true);
          setIsSubmit(true)

          console.log('Received values of form: ', Compte);

          Compte.DATDMC = (new Date(user.datjour)).toLocaleDateString("fr").replaceAll('/', '-') ;
           
          let data = Crypter.encrypt(JSON.stringify(Compte));


          Compte.DATDMC=user.datjour;
          
          let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.SetConditionComptes,
            headers: {
              // 'CypherClient': data,
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: data
          };

          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data));

                if (res.StatutCode == 200) {

                  form.resetFields();

                  localStorage.clear();

                  setIsSubmit(false)
                  SweetAlert.fire({ title: "succées", text: res.Message + " Comptes " + Compte.NUMCPT, icon: "success" });

                  initialiazeButton();

                  setSbmit("");
                }
                else {
                  SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error)
              SweetAlert.fire({ title: "Error", text: error, icon: "error" })
            });
        }
      })
    }
  };

  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {

      errors.push(error.name + "");
    })

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };

  function consult() {
    let data = Crypter.encrypt(form.getFieldValue("NUMCPT"));
    //let clearNumcli = form.getFieldValue("NUMCPT")

    if (data.length !== 0) {
      initialiazeButton();
      setLoading(true);

      //form.resetFields()
      //form.setFieldValue("NUMCPT", clearNumcli)

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetCompte,
        headers: {
          'CypherNumCpte': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };
      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data));
            if (res.StatutCode === 200) {

              let datas: COMPTES = res.Result.Table[0];
              localStorage.clear();

              if (res.Result.Table.length > 0) {

                form.setFieldsValue(res.Result.Table[0]);

                let dateModif = ReformatDate(datas.DATDMC);

                form.setFieldValue("DATDMC", dateModif);
                form.setFieldValue("CATEGOCPT", datas.categocpt);

                switch (datas.CALINT) {
                  case 'O':
                    form.setFieldValue('CALINT', true);
                    break
                  case 'N':
                    form.setFieldValue('CALINT', false);
                    break
                  default:
                    form.setFieldValue('CALINT', false);
                }

                switch (datas.CALCOM) {
                  case 'O':
                    form.setFieldValue('CALCOM', true);
                    break
                  case 'N':
                    form.setFieldValue('CALCOM', false);
                    break
                  default:
                    form.setFieldValue('CALCOM', false);
                }


                form.setFieldValue('lib_NUMCPT', datas.NOMCPT);

                // initialiazeButton();
                cunsultButton();

              } else {
                SweetAlert.fire({ title: "Warning", text: "Account not found", icon: "warning" })
              }
              // console.log(form.getFieldsValue())
            }
            else {
              SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
            }
          }
          setLoading(false)
        })
        .catch((error) => {
          setLoading(false);
          // console.log(error)
          SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
        });
    }
  }

  function modif() {
    modifButton()

  }

  return (
    <div className='tab'>
      <Box className='formTitle'> <Breadcrumbs aria-label="breadcrumb">
        <StyledBreadcrumb
          component="a"
          href="/jjh"
          label="Home"
          icon={<HomeIcon fontSize="small" />}
        />
        <StyledBreadcrumb component="a" href="#" label="Gestion" />
        <StyledBreadcrumb
          label="Controle Comptables"
          deleteIcon={<ExpandMoreIcon />}
        />
      </Breadcrumbs></Box>
      <Spin spinning={loading} size='large' style={{ color: '#116599' }} >
        <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
          <div className='bG'>
            <legend><Typography color={"#116599"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>

                <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                  Consulter
                </Button>

                <Button size='large' className='bt_add' disabled={modifActve} onClick={modif} type="ghost" htmlType="button" block  >
                  Modifier
                </Button>
                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" htmlType="submit" block>
                  Enregistrer
                </Button>
                <Button size='large' className='bt_add' disabled={impActive} type="ghost" htmlType="button" block  >
                  Imprimer
                </Button>
                <Button size='large' className='bt_add' disabled={actuActive} type="ghost" htmlType="button" block  >
                  Actualiser
                </Button>
                <Button size='large' disabled={annulActive} onClick={handleAnulle} className='bt_add' type="ghost" htmlType="reset" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <div >
              <Tabs onChange={e => { if (Activetabs == true) { consult() } }} size='large' type="card" items={items} />
            </div>
            <div>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );


}

export default ControlCpt;

